import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TableComponent from "../../../components/GeneralComponents/SearchTable/tableComponent";
import SearchForAuditSecurityComponent from "./searchForAuditSecurityComponent/searchForAuditSecurityComponent";
import UserHistoryButton from "../../../components/AdministrativeProcedures/commonComponents/UserHistoryButton/UserHistoryButton";

import { getAuditSecurityByData } from "../../../redux/auditSecurityReducer/actionsAuditSecurity";
import { getUserHistory } from "../../../redux/auditActionsSystemReducer/actionAuditActionsSystem";
import {
  getInputsAuditSecurity,
  serInputsAuditSecurity,
} from "./searchForAuditSecurityComponent/optionsSearchForAuditSecurityComponent";

import { SEARCH_AUDIT_SECURITY_COLUMNS } from "../../../components/GeneralComponents/SearchTable/TablesColumns";

const AuditSecurityComponent = () => {
  const dispatch = useDispatch();

  const [directoryLoad, setDirectoryLoad] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [searchData, setSearchData] = useState({
    fio: "",
    startDate: "",
    endDate: "",
  });

  const { userHistory } = useSelector(
    (state) => state.auditActionSystemReducer
  );
  const auditSecurityAll = useSelector((state) => {
    const { auditSecurityReducer } = state;
    return auditSecurityReducer.auditSecurityAll;
  });

  const allAuditSecurityEvents = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allAuditSecurityEvents.map((item) => {
      return {
        value: item.id,
        label: item.name,
        key: "auditSecurityEventId",
      };
    });
  });

  const getSearchData = (data) => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchData(data);

    dispatch(getAuditSecurityByData(data, selectedPage));
  };

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
  };

  const fetchPageData = useCallback((pageIndex) => {
    setSelectedPage(pageIndex);
  }, []);

  const handleShow = () => {
    dispatch(getUserHistory("security/log/", selectedRowData?.id));
  };

  useMemo(() => {
    setSelectedRowData(null);
    dispatch(getAuditSecurityByData(searchData, selectedPage));
  }, [selectedPage]);

  useEffect(() => {
    if (directoryLoad) {
      serInputsAuditSecurity("firstInit", allAuditSecurityEvents);
    }
  }, [directoryLoad]);

  useEffect(() => {
    if (Boolean(allAuditSecurityEvents.length) && !directoryLoad) {
      setDirectoryLoad(true);
    }
  }, [allAuditSecurityEvents]);

  useEffect(() => {
    fetchPageData(0);
  }, []);

  return (
    <>
      <SearchForAuditSecurityComponent
        inputOptions={getInputsAuditSecurity()}
        getSearchData={getSearchData}
      />
      <UserHistoryButton
        isDisabled={!selectedRowData?.id}
        handleShow={handleShow}
        userHistory={userHistory}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={SEARCH_AUDIT_SECURITY_COLUMNS}
        data={auditSecurityAll.content || []}
        totalPages={auditSecurityAll.totalPages || 0}
        totalElements={auditSecurityAll.totalElements || 0}
        selectedPage={selectedPage}
      />
    </>
  );
};

export default AuditSecurityComponent;
